import { useCallback } from 'react';
import { useIsLoggedIn } from 'hooks/user/useIsLoggedIn';
import {
  addNftToCart,
  removeNftFromCart,
  updateCartData
} from 'appRedux/actions';
import { useAppDispatch, useAppSelector } from 'appRedux/hooks';
import { addToCart, emptyCart, removeFromCart } from 'appRedux/restApi/Cart';
import { mapNftForCart } from 'utils/nft/map-nft-for-cart.util';
import { INft } from 'interfaces';

export const useCartHandlers = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useIsLoggedIn();
  const { loading } = useAppSelector(({ cart }) => cart);

  const handleAddToCart = useCallback(
    (nft: INft) => {
      if (!isLoggedIn) {
        const modifiedNft = mapNftForCart(nft);
        dispatch(addNftToCart(modifiedNft));
      } else {
        dispatch(addToCart(nft.id));
      }
    },
    [isLoggedIn]
  );

  const handleRemoveFromCart = useCallback(
    (id: INft['id']) => {
      if (!isLoggedIn) {
        dispatch(removeNftFromCart(id));
      } else {
        dispatch(removeFromCart(id));
      }
    },
    [isLoggedIn]
  );

  const handleEmptyCart = useCallback(() => {
    if (!isLoggedIn) {
      dispatch(updateCartData());
    } else {
      dispatch(emptyCart());
    }
  }, [isLoggedIn]);

  return {
    handleAddToCart,
    handleRemoveFromCart,
    handleEmptyCart,
    loading
  };
};
